const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "my":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "my",
    reducer: reducer,
};

export default data;
